// extracted by mini-css-extract-plugin
export default {"container":"container___GjoKr","title":"title___lh4cI","content":"content___bdX8l"};